import React, { Component } from 'react';
import { htmlWidget, LargeBusiness } from '../../Constants';
class Title extends Component {
    render() {
        const renderContent = content => {
            return { __html: content };
        };
        const hasPTag = title => {
            if (!title) return false; // handle null/empty

            const hasPTag = /<\s*p\b[^>]*>/i.test(title); // matches <p> or <p ...>
            const hasAnyTag = /<\s*\w+[^>]*>/i.test(title); // matches any HTML-like tag

            return hasPTag || !hasAnyTag;
            // return /<p\b[^>]*>(.*?)<\/p>/i.test(title);
        };
        const convertPToH2UnlessUsePTagTrue = title => {
            if (title == null) return title;

            // 1) Convert <p ...>...</p> to <h2 ...>...</h2> unless class contains "p-tag"
            const converted = title.replace(
                /<p\b([^>]*)>(.*?)<\/p>/gis,
                (match, attrs, content) => {
                    // Extract class attribute if present
                    const classMatch = attrs.match(/class\s*=\s*(['"])(.*?)\1/i);
                    const hasPTagClass = classMatch ? /\bp-tag\b/i.test(classMatch[2]) : false;

                    // If it has class "p-tag", skip conversion
                    if (hasPTagClass) {
                        return match;
                    }

                    // Otherwise convert to h2, preserving other attributes
                    const trimmedAttrs = attrs.trim();
                    return `<h2${trimmedAttrs ? ' ' + trimmedAttrs : ''}>${content}</h2>`;
                }
            );

            // 2) If there are no HTML tags at all, wrap the entire title in <h2>
            const hasAnyTag = /<\s*\w+[^>]*>/i.test(converted);
            if (!hasAnyTag) {
                return `<h2>${converted}</h2>`;
            }

            // If there are tags but no <p>, leave as-is
            return converted;
            // return title.replace(/<p\b([^>]*)>(.*?)<\/p>/gi, (match, attrs, content) => {
            //     // If the p tag has class="p-tag", skip conversion
            //     if (/class\s*=\s*["']?p-tag["']?/i.test(attrs)) {
            //         return match;
            //     }
            //     return `<h2${attrs ? ' ' + attrs.trim() : ''}>${content}</h2>`;
            // });
        };
        if (this.props.title) {
            if (this.props.useH1) {
                return (
                    <h1
                        className={
                            'eir-title eir-title-h1 ' +
                            (this.props.fluid
                                ? 'display-4 eir-display-sm-3 eir-display-xl-2'
                                : 'display-4 eir-display-xl-3') +
                            ' ' +
                            this.props.className
                        }>
                        {this.props.title}
                    </h1>
                );
            } else if (LargeBusiness.isLBSite) {
                return (
                    <h3
                        className={
                            'eir-title eir-title-h3 ' +
                            (this.props.fluid
                                ? 'display-4 eir-display-sm-3 eir-display-xl-2'
                                : 'display-4 eir-display-xl-3') +
                            ' ' +
                            this.props.className
                        }>
                        {this.props.title}
                    </h3>
                );
            } else if (this.props.titleHeight) {
                const HeadingSize = this.props.titleHeight;
                return (
                    <HeadingSize className="eir-title mb-3 eir-title-headingSize">
                        {this.props.title}
                    </HeadingSize>
                );
            } else if (hasPTag(this.props.title)) {
                return (
                    <div
                        className={
                            htmlWidget +
                            'eir-title ' +
                            (this.props.fluid
                                ? 'display-4 eir-display-sm-3 eir-display-xl-2'
                                : 'display-4 eir-display-xl-3') +
                            ' ' +
                            this.props.className
                        }
                        dangerouslySetInnerHTML={renderContent(
                            convertPToH2UnlessUsePTagTrue(this.props.title)
                        )}
                    />
                );
            } else {
                // return <h2 className={'eir-title eir-title-h2 ' + (this.props.fluid ? 'display-4 eir-display-sm-3 eir-display-xl-2' : 'display-4 eir-display-xl-3') + ' ' + this.props.className}
                // >{this.props.title}</h2>;
                return (
                    <div
                        className={
                            htmlWidget +
                            'eir-title ' +
                            (this.props.fluid
                                ? 'display-4 eir-display-sm-3 eir-display-xl-2'
                                : 'display-4 eir-display-xl-3') +
                            ' ' +
                            this.props.className
                        }
                        dangerouslySetInnerHTML={renderContent(this.props.title)}
                    />
                );
            }
        } else {
            return null;
        }
    }
}

export default Title;
